var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSustainabilityinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 18,
  r: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 9.999v-4m0 23.998v-4m8.003-7.996h4m-24 0h4m14.07-6.073L40.9 9.1M23.103 26.898l2.829-2.828m12.14.004 2.829 2.828M23.103 9.105l2.828 2.829M27 53c0-12.15 9.85-22 22-22 1.466 0 2.9.143 4.285.417C53.752 33.2 54 35.071 54 37c0 12.15-9.85 22-22 22-1.466 0-2.9-.143-4.285-.417A22 22 0 0 1 27 53z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27 53c0 1.929.248 3.8.715 5.583q1.04.206 2.112.311C18.697 57.803 10 48.417 10 37c0-1.929.248-3.8.715-5.583A22 22 0 0 1 15 31c6.848 0 12.965 3.129 17 8.035A21.9 21.9 0 0 0 27 53zm5 6q-1.1 0-2.173-.106zm-4-1 25-26M36 50V35M25 46v-8m-9-1v-6m30 8v-7M33 53h6.5M15 51h12.5M11 43h11m18.487 2H52m-24.5 3.5L11 32"
}))));
export default SvgSustainabilityinline;